import mock from '../mocks/omv';

export function useOmv() {
  const omv = mock;
  return omv;
};